import { Pipe, PipeTransform } from "@angular/core";
import { marked } from "marked";
import DOMPurify from "dompurify";

@Pipe({
  name: "markdown",
  standalone: true,
  pure: true,
})
export class MarkdownPipe implements PipeTransform {
  async transform(value: string | null | undefined): Promise<string> {
    if (!value) return "";
    const rawHtml = await marked.parse(value, { async: true });
    return DOMPurify.sanitize(rawHtml);
  }
}
